import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CasellaConfigService, ROUTER_URLS } from '@portal/common';
import { ButtonDirective } from '@portal/ui-common';
import { GtmLinkClickDirective } from '@shared/gtm';
import { ICON_PATH_TOKEN } from '@shared/ui-shared';

@Component({
  selector: 'csl-home-page',
  standalone: true,
  imports: [ButtonDirective, RouterLink, GtmLinkClickDirective],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageComponent {
  private readonly configService = inject(CasellaConfigService);

  iconPath = inject(ICON_PATH_TOKEN);
  contactUsUrl = this.configService.config.CONTACT_US_URL;

  routerUrls = {
    residential: `/${ROUTER_URLS.residential}`,
    rollOff: `/${ROUTER_URLS.rollOff}`,
    commercial: `/${ROUTER_URLS.commercial}`,
  };
}
